import { trimCanvas } from './trimCanvas'

export const estimateCanvasFontSize = ({
  length: textSize,
}: {
  length: number
}) => {
  if (textSize <= 12) return 50
  else if (textSize <= 16) return 45
  else if (textSize <= 22) return 38
  else if (textSize <= 32) return 27
  else return 20
}

export const convertTextToImage = (text: string, fontFamily: string) => {
  const fontSize = estimateCanvasFontSize(text)
  const canvas = document.createElement('canvas')

  canvas.id = 'hiddenCanvas'
  canvas.setAttribute('width', '445')
  canvas.setAttribute('height', '77')
  canvas.setAttribute('style', 'position: absolute;left:-9999px;')

  const context = canvas.getContext('2d')!
  context.clearRect(0, 0, canvas.width, canvas.height)
  context.font = `${fontSize}px ${fontFamily}`
  context.fillText(text, 0, 50)

  return trimCanvas(canvas).toDataURL()
}
